export default __webpack_public_path__ + "static/media/person3.a408d3c9.png";